module.exports = __webpack_public_path__ + "media/app/assets/mailers/instagram-light-82177d625b24568cb4a4e34933fedeaf.png";